// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".liste_annuaire{overflow-y:auto;max-height:calc(100vh - 180px);scrollbar-width:thin}.header_annuaire{padding-left:0!important;padding-top:0!important;padding-bottom:0!important}.panel_annuaire{border-style:solid;border-width:1px;border-color:#e0e0e0}.v-expansion-panel:before{-webkit-box-shadow:none!important;box-shadow:none!important}.v-expansion-panel{border-top:0}", ""]);
// Exports
module.exports = exports;
